import { Field } from './Field/Field';

type Props = {
  name: string;
  qaId?: string;
};

export function HiddenField({ name, qaId }: Props) {
  return (
    <Field
      name={name}
      renderInput={({ value, id, qaId: fieldQaId }) => (
        <input
          id={id}
          name={name}
          value={(value as string) ?? ''}
          data-qa-id={qaId ?? fieldQaId}
          hidden
          readOnly
        />
      )}
      hidden
    />
  );
}
